export default "__VITE_ASSET__639134ca__"